<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Card</h4>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-sm-8">
            <label>Name</label>
            <input class="form-control" [(ngModel)]="name" placeholder="Card name" type="text">
          </div>
          <div class="col-sm-4">
            <label>Rank</label>
            <select class="form-control" [(ngModel)]="rankType">
              @for (t of rankTypes; track t[1]) {
                <option [ngValue]="t[1]">{{ t[0] }}</option>
              }
            </select>
          </div>
        </div>

        <hr/>
        <h6>Translations</h6>
        @for (t of translations; track t.languageId) {
          <div class="input-group mb-2">
            <span class="input-group-text" style="min-width: 80px">{{ t.languageIso }}</span>
            <input class="form-control" [(ngModel)]="t.name" placeholder="Name" type="text">
          </div>
        }
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Add
        </button>
      </div>
    </div>
  </div>
</div>
